module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_7.2c0166ca.jpg";